import React from 'react';
import { DialogPromptFeedbackButton } from '../../api/DialogPromptApi';
import DialogPromptComponent from './DialogPromptComponent';

interface DialogPromptFeedbackButtonComponentProps {
    dialogPrompt: DialogPromptFeedbackButton;
    setDialogPromptComplete: (dialogPromptId: number) => void;
    showAvatar?: boolean;
    chatBubbleContainerRef: React.RefObject<HTMLDivElement>;
    isSettings?: boolean;
}

const DialogPromptFeedbackButtonComponent: React.FC<DialogPromptFeedbackButtonComponentProps> = ({
    dialogPrompt,
    setDialogPromptComplete,
    showAvatar = true,
    chatBubbleContainerRef,
    isSettings = false
}) => (
    <DialogPromptComponent
        dialogPrompt={dialogPrompt}
        setDialogPromptComplete={setDialogPromptComplete}
        showAvatar={showAvatar}
        chatBubbleContainerRef={chatBubbleContainerRef}
        isSettings={isSettings}
    />
);

export default DialogPromptFeedbackButtonComponent;
